import MUIMasonry, { MasonryProps } from '@mui/lab/Masonry';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';

const Masonry = ({ children, spacing = 1, columns: c, ...props }: MasonryProps) => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.mediaQueries.mobile);
  const isTablet = useMediaQuery(theme.mediaQueries.tablet);
  const isDesktop = useMediaQuery(theme.mediaQueries.desktop);

  const columns = useMemo(() => {
    if (isDesktop) return 3;
    if (isTablet) return 2;
    if (isMobile) return 1;

    return 1;
  }, [isMobile, isTablet, isDesktop]);

  return (
    <MUIMasonry spacing={spacing} columns={columns} {...props}>
      <>{children}</>
    </MUIMasonry>
  );
};

export default Masonry;
